 import axios from 'axios'

const state = () => ({
  kurslar: []
})

const getters = {
  kurslar(state) {
    return state.kurslar
  }
}

const mutations = {
  SET_KURSLAR(state, payload){
    state.kurslar = payload
  },
  DELETE_KURSLAR(state, id){
    state.kurslar.results = state.kurslar.results?.filter((x) => x.id != id);
  },
  ADD_KURSLAR(state, data){
    state.kurslar.results.push(data);
  },
  EDIT_KURSLAR(state, payload){
    state.kurslar.results = state.kurslar.results.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getKurslar({commit}){
    axios.get('https://api.geomalaka.uz/api/about/kurslar/')
    .then((res)=>{
      commit("SET_KURSLAR", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteKurslar({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/about/kurslar/${id}/`)
    .then((res)=>{
      commit("DELETE_KURSLAR", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addKurslar({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/about/kurslar/', payload)
    .then((res)=>{
      commit("ADD_KURSLAR", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editKurslar({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/about/kurslar/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_KURSLAR", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
